import {svgIconWrapper} from '../svg-icon-wrapper';

import ClaudeOutlineAI from './claude-outline-ai-icon.svg';

function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
    return <ClaudeOutlineAI {...props} />;
}

SvgComponent.iconName = 'claudeOutlineAI';

export const ClaudeOutlineAIIcon = svgIconWrapper(SvgComponent);
